// Search animation for whole site
import $ from 'jquery';
import config from './globals/config';

export default {
  // widths of search input on animate open
  inputWidthMobile : -65,
  inputWidthDesktop: 240,

  init: function (isMobile) {
    this.setEls();
    this.registerEvents();

    this.isMobile = isMobile;
  },

  setEls: function () {
    this.parentEl = $('.search-input-container');
    this.inputEl = $('.search-input');
    this.formEl = $('.search-form');
    this.btn = $('.search-btn');
    this.headerLi = $('#menu-main-nav li, .top-bar-all-link');
    this.openClass = 'search-open';
    this.logo = $('.top-bar-container .name, .top-bar-container .title h1');
  },

  registerEvents: function () {
    let self = this;

    this.formEl.on('submit', function (e) {
      e.preventDefault();
    });

    this.btn.on('click', function (e) {
      e.preventDefault();

      if (!self.parentEl.hasClass(self.openClass)) {
        if (config.theWindow.width() < 1085 && config.theWindow.width() > 640) {
          self.headerLi.velocity('top-bar-exit-search', { stagger : 100, complete: function () {
            self.openSearch();
            self.parentEl.addClass(self.openClass);
          } });

        } else {
          self.openSearch();
          self.parentEl.addClass(self.openClass);
        }

        self.inputEl.focus();

      } else {
        self.parentEl.removeClass(self.openClass);

        if (config.theWindow.width() < 1085 && config.theWindow.width() > 640) {
          self.closeSearch(function () {
            self.headerLi.velocity('top-bar-intro');
          });

        } else {
          self.closeSearch();
        }
      }
    });
  },

  openSearch: function () {
    if (config.theWindow.width() <= 640) {
      this.logo.addClass('hide-force');
    }

    let openWidth = (config.theWindow.width() <= 640) ?
      config.theWindow.width() + this.inputWidthMobile :
      this.inputWidthDesktop;

    if ($('body').hasClass('home')) {
      openWidth += 7;
    }
    this.inputEl.velocity({ width: openWidth }, { duration: config.animationTiming / 4, easing: config.easing });
  },

  closeSearch: function (callback) {
    let self = this;

    this.inputEl.velocity({ width: 0 }, {
      duration: config.animationTiming / 4,
      easing  : config.easing,
      complete: function () {
        if (callback) {
          callback();
        }

        if (config.theWindow.width() <= 640) {
          self.logo.removeClass('hide-force');
        }
      },
    });
  },

  closeSearchOnScroll: function (callback) {
    this.parentEl.removeClass(this.openClass);

    this.inputEl.velocity({ width: 0 }, {
      duration: config.animationTiming,
      easing  : config.easing,
      complete: function () {
        if (callback) {
          callback();
        }
      },
    });
  },

  onScroll: function () {
    let self = this;

    // close search bar
    if (this.isMobile || config.theWindow.width() < 641) {
      return;
    }

    if (self.parentEl.hasClass(self.openClass)) {
      // if the less wide width, the ui is too small to animate fully
      if (config.theWindow.width() < 1085 && config.theWindow.width() > 640) {
        this.closeSearchOnScroll(function () {
          self.headerLi.velocity('top-bar-intro');
        });
      } else {
        this.closeSearchOnScroll();
      }
    }

    if (config.theWindow.width() <= 640) {
      let title = $('.name, .title h1');

      if (title.hasClass('hide-force')) {
        title.removeClass('hide-force');
      }
    }
  },
};
